import React from 'react';
import Table from '../common/Table';
import { formatNumber, formatCurrency, formatPercent } from '../../utils/formatters';
import Button from '../common/Button';
import '../../../src/styles/animations.css';

const PositionTable = ({ positions, flashingCells }) => {
  const columns = [
    { header: '종목', accessor: 'symbol' },
    { header: '방향', accessor: 'direction', render: (row) => (
      <span className={row.direction === 'Long' ? 'text-red-500' : 'text-blue-500'}>
        {row.direction}
      </span>
    )},
    { header: '수량', accessor: 'quantity', render: (row) => `${row.quantity}계약` },
    { header: '평균가', accessor: 'avgPrice', render: (row) => formatNumber(row.avgPrice) },
    { header: '현재가', accessor: 'currentPrice', render: (row) => (
      <span className={flashingCells[row.id] ? 'flash' : ''}>
        {formatNumber(row.currentPrice)}
      </span>
    )},
    { header: '평가손익', accessor: 'profitLoss', render: (row) => (
      <span className={row.profitLoss >= 0 ? 'text-green-500' : 'text-red-500'}>
        {formatCurrency(row.profitLoss)} ({formatPercent(row.profitRate)})
      </span>
    )},
    { header: '액션', accessor: 'id', render: () => (
      <Button size="sm" variant="danger" disabled>청산</Button>
    )},
  ];

  return <Table columns={columns} data={positions} />;
};

export default PositionTable;
